import { apiRequest } from "../api";

export const getCategories = () => apiRequest("/categories", "GET");
export const saveCategory = (endpoint: string, method: string, payload: unknown) =>
  apiRequest(endpoint, method, payload);
export const deleteCategory = (id: string) =>
  apiRequest(`/categories/${id}`, "DELETE");
export const deleteSubCategory = (id: string) =>
  apiRequest(`/sub-categories/${id}`, "DELETE");
